var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointDragHandle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.871,
    height: 52.871,
    viewBox: "0 0 52.871 52.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3122",
    "data-name": "Group 3122",
    transform: "translate(-238.202 -279.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3118",
    "data-name": "Group 3118",
    transform: "translate(-15.293 -9.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3116",
    "data-name": "Group 3116",
    transform: "translate(249.961 324.788) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M0,0V15.765",
    transform: "translate(9.456 14.639)",
    fill: "none",
    stroke: "#04104c",
    strokeWidth: 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_6",
    "data-name": "Polygon 6",
    d: "M6.456,0l6.456,11.129H0Z",
    transform: "translate(3 3.533)",
    fill: "#04104c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3119",
    "data-name": "Group 3119",
    transform: "translate(544.568 621.371) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3116-2",
    "data-name": "Group 3116",
    transform: "translate(249.961 324.788) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1379-2",
    "data-name": "Path 1379",
    d: "M0,0V15.765",
    transform: "translate(9.456 14.639)",
    fill: "none",
    stroke: "#04104c",
    strokeWidth: 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_6-2",
    "data-name": "Polygon 6",
    d: "M6.456,0l6.456,11.129H0Z",
    transform: "translate(3 3.533)",
    fill: "#04104c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3120",
    "data-name": "Group 3120",
    transform: "translate(-50.694 585.969) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3116-3",
    "data-name": "Group 3116",
    transform: "translate(249.961 324.788) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1379-3",
    "data-name": "Path 1379",
    d: "M0,0V15.765",
    transform: "translate(9.456 14.639)",
    fill: "none",
    stroke: "#04104c",
    strokeWidth: 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_6-3",
    "data-name": "Polygon 6",
    d: "M6.456,0l6.456,11.129H0Z",
    transform: "translate(3 3.533)",
    fill: "#04104c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3121",
    "data-name": "Group 3121",
    transform: "translate(579.97 26.109) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3116-4",
    "data-name": "Group 3116",
    transform: "translate(249.961 324.788) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_6-4",
    "data-name": "Polygon 6",
    d: "M6.456,0l6.456,11.129H0Z",
    transform: "translate(3 3.533)",
    fill: "#04104c"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(260.702 302)",
    fill: "#04104c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointDragHandle);
export default __webpack_public_path__ + "static/media/point-drag-handle.d37789bae37d55ae5ae67a2693912b19.svg";
export { ForwardRef as ReactComponent };